var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLarg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.017,
    y1: 1,
    x2: 1.19,
    y2: 0.249,
    id: "video_large_prefix__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "29.327%",
    stopColor: "#221FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F61FF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "video_large_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video_large_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.283 4.12a.3.3 0 01-.147-.147l-.864-1.875a.3.3 0 00-.545 0l-.864 1.875a.3.3 0 01-.147.147l-1.875.864a.3.3 0 000 .545l1.875.864a.3.3 0 01.147.147l.864 1.875a.3.3 0 00.545 0l.864-1.875a.3.3 0 01.147-.147l1.875-.864a.3.3 0 000-.545l-1.875-.864zm3.436 14.138V8.93a1.125 1.125 0 00-2.25 0v9.328q0 .375-.375.375H2.906q-.375 0-.375-.375V5.742q0-.155.11-.265.11-.11.265-.11h10.406a1.125 1.125 0 100-2.25H2.906q-1.087 0-1.856.769-.769.769-.769 1.856v12.516q0 1.087.77 1.856.768.769 1.855.769h18.188q1.087 0 1.856-.77.769-.768.769-1.855zM9.27 8.972a.6.6 0 01.924-.505l4.688 3.006a.6.6 0 01.003 1.009l-4.688 3.042a.6.6 0 01-.927-.504V8.972z",
    fillRule: "evenodd",
    fill: "url(#video_large_prefix__b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLarg);
export default __webpack_public_path__ + "static/media/video_larg.15cd951f.svg";
export { ForwardRef as ReactComponent };